import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch, scope) => {
    axios
      .get(routes.api.super_admins.coaches.index, {
        params: {
          scope,
        },
      })
      .then((resp) => {
        dispatch({ type: 'LOAD', coaches: resp.data.data });
      });
  },
  destroy: (dispatch, id, callback) => {
    axios
      .delete(routes.api.super_admins.users.destroy(id))
      .then(() => {
        dispatch({ type: 'DESTROY', id });
        callback();
      });
  },
  restore: (dispatch, id) => {
    axios
      .post(routes.api.super_admins.users.restore(id))
      .then(() => {
        dispatch({ type: 'RESTORE', id });
      });
  },

};
